import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  menuPaper: {
    width: 380,
    maxHeight: 480,
    marginTop: 1,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 16px",
  },
  title: {
    fontWeight: 600,
  },
  closeButton: {
    padding: 4,
  },
  groupContainer: {
    marginBottom: 8,
  },
  groupHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.light,
    borderRadius: "4px 4px 0 0",
  },
  groupTitle: {
    flex: 1,
    fontWeight: 600,
    fontSize: "0.875rem",
  },
  chip: {
    height: 20,
    fontSize: "0.7rem",
  },
  listContainer: {
    maxHeight: 200,
    overflowY: "auto",
    padding: 0,
  },
  listItem: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: "8px 16px",
  },
  actionButtons: {
    display: "flex",
    gap: 4,
  },
  emptyState: {
    padding: "32px 16px",
    textAlign: "center",
  },
  notificationIcon: {
    fontSize: 40,
    color: theme.palette.text.disabled,
    marginBottom: 8,
  },
  loadingContainer: {
    padding: "32px 16px",
    textAlign: "center",
  },
  errorText: {
    padding: "24px 16px",
    textAlign: "center",
    color: theme.palette.error.main,
  },
  secondaryText: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    flexWrap: "wrap",
  },
  dialog: {
    maxWidth: "sm",
    fullWidth: true,
  },
  dialogTitle: {
    padding: "16px 24px 8px",
  },
  dialogContent: {
    padding: "8px 24px 16px",
  },
  dialogActions: {
    padding: "8px 24px 16px",
  },
}));
